import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Index from './pages/index';

import GridLayoutWithSidebar from './pages/property/grid-layout-with-sidebar';
import Property from './pages/property/list-layout-one';
import ScrollToTop from './components/scroll-to-top';
import ScrollToTopOnNav from './components/scroll-to-top-on-nav';
import Contact from './pages/contact';
import AboutUs from './pages/about-us';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Agents from './pages/agents/agents';
import AgentPage from './pages/agents/agent-page';
import AgencyPage from './pages/agents/agency-page';
import SinglePropertyOne from './pages/property/property-details';

// Admin Pages
import Login from './pages/admin/login';
import CreateAccount from './pages/admin/create-account';
import Dashboard from './pages/admin/dashboard';
import MyProfile from './pages/admin/my-profile';
import MyProperty from './pages/admin/my-property';
import BookmarkList from './pages/admin/bookmark-list';
import SubmitPropertyDashboard from './pages/admin/submit-property-dashboard';
import ChangePassword from './pages/admin/change-password';
import ResetPassword from './pages/admin/reset-password';

// Agent Dashboard Pages (Separate Green Panel)
import AgentDashboard from './pages/agents/agent-dashboard';
import AgentProfile from './pages/agents/agent-profile';
import AgentMyProperty from './pages/agents/agent-my-property';
import AgentAddProperty from './pages/agents/agent-add-property';
import AgentChangePassword from './pages/agents/agent-change-password';

// Admin Panel Pages (Separate Dark Panel)
import AdminDashboard from './pages/admin/admin-dashboard';
import AdminClassifiedDashboard from './pages/admin/admin-classified-dashboard';
import AdminLeadClassifiedPackages from './pages/admin/admin-lead-classified-packages';
import AdminLeadSubscriptions from './pages/admin/admin-lead-subscriptions';
import BrokerBuyLeadPlan from './pages/broker/broker-buy-lead-plan';
import BrokerPurchasedPlans from './pages/broker/broker-purchased-plans';
import AdminOwnerProperties from './pages/admin/admin-owner-properties';
import AdminBrokerProperties from './pages/admin/admin-broker-properties';
import AdminBuilderProjects from './pages/admin/admin-builder-projects';
import AdminMyProperties from './pages/admin/admin-my-properties';
import AdminSavedProperties from './pages/admin/admin-saved-properties';
import AdminEditClassifiedProperty from './pages/admin/admin-edit-classified-property';
import AdminUsers from './pages/admin/admin-users';
import AdminSubAdmins from './pages/admin/admin-sub-admins';
import AdminAllProperties from './pages/admin/admin-all-properties';
import AdminProfile from './pages/admin/admin-profile';
import AdminChangePassword from './pages/admin/admin-change-password';
import AdminAddProperty from './pages/admin/admin-add-property';
import AdminEditProperty from './pages/admin/admin-edit-property';
import AdminAmenities from './pages/admin/admin-amenities';
import AdminBookings from './pages/admin/admin-bookings';
import AdminCities from './pages/admin/admin-cities';
import AdminDevelopers from './pages/admin/admin-developers';
import AdminAddDeveloper from './pages/admin/admin-add-developer';
import AdminEditDeveloper from './pages/admin/admin-edit-developer';
import AdminManagePodcasts from './pages/admin/admin-manage-podcasts';
import AdminManageReels from './pages/admin/admin-manage-reels';
import AdminTestimonials from './pages/admin/admin-testimonials';
import AdminBlogs from './pages/admin/admin-blogs';
import AdminProjects from './pages/admin/admin-projects';
import AdminDrafts from './pages/admin/admin-drafts';
import AdminAddProject from './pages/admin/admin-add-project';
import AdminMedia from './pages/admin/admin-media';
import AdminEditProject from './pages/admin/admin-edit-project';
import AdminInventory from './pages/admin/admin-inventory';
import AdminLeads from './pages/admin/admin-leads';
import AdminFollowUps from './pages/admin/admin-followups';
import AdminCustomers from './pages/admin/admin-customers';
import AdminIcons from './pages/admin/admin-icons';
import AdminSpecifications from './pages/admin/admin-specifications';
import AdminPackageSubscriptions from './pages/admin/admin-package-subscriptions';
import AdminProjectDetails from './pages/admin/admin-project-details';
import AdminLocalities from './pages/admin/admin-localities';
import AdminEditLocality from './pages/admin/admin-edit-locality';
import AdminHeroBanners from './pages/admin/admin-hero-banners';
import AdminBlogComments from './pages/admin/admin-blog-comments';
import AdminLocalityHighlights from './pages/admin/admin-locality-highlights';
import AdminPackages from './pages/admin/admin-packages';
import AdminPropertyTypes from './pages/admin/admin-property-types';
import AdminAddPropertyType from './pages/admin/admin-add-property-type';
import AdminEditPropertyType from './pages/admin/admin-edit-property-type';
import AdminPropertySubtypes from './pages/admin/admin-property-subtypes';
import AdminAddPropertySubtype from './pages/admin/admin-add-property-subtype';
import AdminDefaultLeadImages from './pages/admin/admin-default-lead-images';

import AdminAddPackage from './pages/admin/admin-add-package';
import AdminEditPackage from './pages/admin/admin-edit-package';
import AdminPackageInquiries from './pages/admin/admin-package-inquiries';
import AdminInquiries from './pages/admin/admin-inquiries';
import AdminLocalityPoints from './pages/admin/admin-locality-points';
import AdminPriceTrends from './pages/admin/admin-price-trends';
import AdminLandmarkCategories from './pages/admin/admin-landmark-categories';
import ProjectList from './pages/project/project-list';
import ProjectDetails from './pages/project/project-details';

import CompareProjects from './pages/project/compare-projects';
import Localities from './pages/location/localities';
import LocationDetails from './pages/location/location-details';
import Blog from './pages/blog/blog';
import BlogDetail from './pages/blog/blog-detail';
import Reels from './pages/blog/reels';
import Podcasts from './pages/blog/podcasts';
import PrivacyPolicy from './pages/privacy-policy';
import TermsAndConditions from './pages/terms';
import Faq from './pages/faq';

// Developer Panel Pages (Brown/Gold Theme)
import DevDashboard from './pages/developer/dev-dashboard';
import DevProfile from './pages/developer/dev-profile';
import DevMyProperty from './pages/developer/dev-my-property';
import DevAddProperty from './pages/developer/dev-add-property';
import DevChangePassword from './pages/developer/dev-change-password';
import DevAddProject from './pages/developer/dev-add-project';
import DevInventory from './pages/developer/dev-inventory';
import DeveloperPage from './pages/developer/developer-page';
import OwnerProfile from './pages/owner/owner-profile';
import DeveloperList from './pages/developer/developer-list';
import DeveloperPackages from './pages/developer/developer-packages';
import DevDrafts from './pages/developer/dev-drafts';
import BrokerPackages from './pages/broker/broker-packages';
import OwnerPackages from './pages/owner/owner-packages';

// Tool Pages
import EMICalculatorPage from './pages/tools/EMICalculatorPage';
import AffordabilityCalculatorPage from './pages/tools/AffordabilityCalculatorPage';
import EligibilityCalculatorPage from './pages/tools/EligibilityCalculatorPage';
import VastuCalculatorProcess from './pages/tools/VastuCalculatorProcess';
import DownPaymentCalculatorPage from './pages/tools/DownPaymentCalculatorPage';
import RealEstateInvestmentCalculatorPage from './pages/tools/RealEstateInvestmentCalculatorPage';
import RentalYieldCalculatorPage from './pages/tools/RentalYieldCalculatorPage';
import OfficeSpaceCalculatorPage from './pages/tools/OfficeSpaceCalculatorPage';
import RentVsBuyCalculatorPage from './pages/tools/RentVsBuyCalculatorPage';
import VastuAIPage from './pages/tools/VastuAIPage';
import LocalityTrendsPage from './pages/locality/LocalityTrendsPage';

// Role-Specific Dashboards
import BuyerDashboard from './pages/buyer/buyer-dashboard';
import BuyerInquiries from './pages/buyer/buyer-inquiries';
import TenantDashboard from './pages/tenant/tenant-dashboard';
import OwnerDashboard from './pages/owner/owner-dashboard';
import BrokerDashboard from './pages/broker/broker-dashboard';
import BrokerProfile from './pages/broker/broker-profile';
import BrokerAddProject from './pages/broker/broker-add-project';
import BrokerMyProjects from './pages/broker/broker-my-projects';
import BrokerLeads from './pages/broker/broker-leads';
import BrokerInquiries from './pages/broker/broker-inquiries';
import BrokerWishlist from './pages/broker/broker-wishlist';
import BrokerChangePassword from './pages/broker/broker-change-password';
import BrokerClassifiedAds from './pages/broker/broker-classified-ads';
import SavedClassifiedLeads from './pages/broker/saved-classified-leads';

import OwnerMyProperty from './pages/owner/owner-my-property';
import OwnerEditProperty from './pages/owner/owner-edit-property';
import OwnerAddProject from './pages/owner/owner-add-project';

import MyPackagePage from './pages/shared/my-package';

import AdminSiteVisibility from './pages/admin/admin-site-visibility';
import AdminHomepageSettings from './pages/admin/admin-homepage-settings';
import AdminSEO from './pages/admin/admin-seo';
import AdminLeadSettings from './pages/admin/admin-lead-settings';
import AdminScoreManagement from './pages/admin/admin-score-management';
import AdminLegal from './pages/admin/admin-legal';
import ComingSoonPage from './components/ComingSoonPage';
import MobileBottomNav from './components/MobileBottomNav';

import { useAuth } from './context/AuthContext';
import api from './utils/api';

import DisclaimerModal from './components/DisclaimerModal';

function App() {
  const { user } = useAuth();
  const [maintenanceMode, setMaintenanceMode] = React.useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = React.useState('');
  const [maintenanceImage, setMaintenanceImage] = React.useState('');
  const [maintenanceMobileImage, setMaintenanceMobileImage] = React.useState('');
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const checkSettings = async () => {
      try {
        const data = await api.getSystemSettings();
        if (data && !data.message) {
          setMaintenanceMode(data.isMaintenanceMode);
          setMaintenanceMessage(data.maintenanceMessage);
          setMaintenanceImage(data.bannerImage);
          setMaintenanceMobileImage(data.mobileBannerImage);

          // SEO & Tracking Script Injection
          if (data.googleAnalyticsId) {
            const script = document.createElement('script');
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${data.googleAnalyticsId}`;
            document.head.appendChild(script);

            const script2 = document.createElement('script');
            script2.innerHTML = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${data.googleAnalyticsId}');
            `;
            document.head.appendChild(script2);
          }

          if (data.googleTagManagerId) {
            const script = document.createElement('script');
            script.innerHTML = `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${data.googleTagManagerId}');
            `;
            document.head.appendChild(script);
          }

          if (data.facebookPixelId) {
            const script = document.createElement('script');
            script.innerHTML = `
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '${data.facebookPixelId}');
              fbq('track', 'PageView');
            `;
            document.head.appendChild(script);
          }

          if (data.googleSiteVerification) {
            const meta = document.createElement('meta');
            meta.name = 'google-site-verification';
            meta.content = data.googleSiteVerification;
            document.head.appendChild(meta);
          }
        }
      } catch (err) {
        console.error('System settings check failed:', err);
      } finally {
        setLoading(false);
      }
    };
    checkSettings();
  }, []);

  // While checking maintenance mode, show nothing or a small loader
  if (loading) return null;

  // If maintenance mode is active AND user is not an admin, show Coming Soon page
  // We allow /login to always be accessible so admins can enter
  const isPublicPath = !window.location.pathname.startsWith('/admin') && 
                       !window.location.pathname.startsWith('/developer') &&
                       !window.location.pathname.startsWith('/agent') &&
                       !window.location.pathname.startsWith('/broker') &&
                       !window.location.pathname.startsWith('/owner') &&
                       !window.location.pathname.startsWith('/buyer') &&
                       !window.location.pathname.startsWith('/tenant') &&
                       window.location.pathname !== '/login' &&
                       window.location.pathname !== '/create-account' &&
                       !window.location.pathname.startsWith('/reset-password');

  if (maintenanceMode && isPublicPath && user?.role !== 'admin') {
    return (
      <>
        <ScrollToTopOnNav />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path='/reset-password/:token' element={<ResetPassword />} />
          <Route path="*" element={<ComingSoonPage message={maintenanceMessage} image={maintenanceImage} mobileImage={maintenanceMobileImage} />} />
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
        <ScrollToTop />
        <DisclaimerModal />
      </>
    );
  }

  return (
    <>
      <ScrollToTopOnNav />

      <Routes>
        {/* Auth Pages - Moved to top for priority */}
        <Route path='/reset-password/:token' element={<ResetPassword />} />
        <Route path='/login' element={<Login />} />
        <Route path='/create-account' element={<CreateAccount />} />

        {/* Public Pages */}
        <Route path='/' element={<Index />} />
        <Route path='/grid-layout-with-sidebar' element={<GridLayoutWithSidebar />} />
        <Route path='/property' element={<Property />} />
        <Route path='/list-layout-with-sidebar' element={<Property />} />
        <Route path='/about-us' element={<AboutUs />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/agents' element={<Agents />} />
        <Route path='/agent-page' element={<AgentPage />} />
        <Route path='/agent-page/:id' element={<AgentPage />} />
        <Route path='/agency-page/:id' element={<AgencyPage />} />
        <Route path='/property-details/:id' element={<SinglePropertyOne />} />
        <Route path='/project-list' element={<ProjectList />} />
        <Route path='/developer-list' element={<DeveloperList />} />
        <Route path='/developer-packages' element={<DeveloperPackages />} />
        <Route path='/broker-packages' element={<BrokerPackages />} />
        <Route path='/owner-packages' element={<OwnerPackages />} />
        <Route path='/project-details/:slug' element={<ProjectDetails />} />
        <Route path='/locations' element={<Localities />} />
        <Route path='/location/:slug' element={<LocationDetails />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/blog-detail/:id' element={<BlogDetail />} />
        <Route path='/reels' element={<Reels />} />
        <Route path='/podcasts' element={<Podcasts />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/terms' element={<TermsAndConditions />} />
        <Route path='/faq' element={<Faq />} />
        <Route path='/faqs' element={<Faq />} />
        <Route path='/location-trends/:slug' element={<LocalityTrendsPage />} />
        <Route path='/compare-projects' element={<CompareProjects />} />
        
        {/* Tool Pages */}
        <Route path='/emi-calculator' element={<EMICalculatorPage />} />
        <Route path='/affordability-calculator' element={<AffordabilityCalculatorPage />} />
        <Route path='/eligibility-calculator' element={<EligibilityCalculatorPage />} />
        <Route path='/real-estate-investment-calculator' element={<RealEstateInvestmentCalculatorPage />} />
        <Route path='/rental-yield-calculator' element={<RentalYieldCalculatorPage />} />
        <Route path='/office-space-calculator' element={<OfficeSpaceCalculatorPage />} />
        <Route path='/rent-vs-buy-calculator' element={<RentVsBuyCalculatorPage />} />
        <Route path='/down-payment-calculator' element={<DownPaymentCalculatorPage />} />
        <Route path='/vastu-calculator-process' element={<VastuCalculatorProcess />} />
        <Route path='/vastu-ai-calculator' element={<VastuAIPage />} />

        {/* Auth Pages (moved to top) */}


        {/* Admin Dashboard Pages */}
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/my-profile' element={<MyProfile />} />
        <Route path='/my-property' element={<MyProperty />} />
        <Route path='/bookmark-list' element={<BookmarkList />} />
        <Route path='/submit-property-dashboard' element={<SubmitPropertyDashboard />} />
        <Route path='/change-password' element={<ChangePassword />} />

        {/* Agent Dashboard Pages (Separate Green Panel) */}
        <Route path='/agent-dashboard' element={<AgentDashboard />} />
        <Route path='/agent-profile' element={<AgentProfile />} />
        <Route path='/agent-my-property' element={<AgentMyProperty />} />
        <Route path='/agent-add-property' element={<AgentAddProperty />} />
        <Route path='/agent-change-password' element={<AgentChangePassword />} />

        {/* Admin Panel Pages (Dark Navy/Red Theme) */}
         <Route path='/admin-dashboard' element={<AdminDashboard />} />
            <Route path='/admin-classified-dashboard' element={<AdminClassifiedDashboard />} />
            <Route path='/admin-default-lead-images' element={<AdminDefaultLeadImages />} />
          <Route path='/admin-lead-subscriptions' element={<AdminLeadSubscriptions />} />
          <Route path='/admin-package-subscriptions' element={<AdminPackageSubscriptions />} />
          <Route path='/admin-lead-classified-packages' element={<AdminLeadClassifiedPackages />} />
          <Route path='/admin-owner-properties' element={<AdminOwnerProperties />} />
         <Route path='/admin-broker-properties' element={<AdminBrokerProperties />} />
         <Route path='/admin-builder-projects' element={<AdminBuilderProjects />} />
         <Route path='/admin-my-properties' element={<AdminMyProperties />} />
         <Route path='/admin-saved-properties' element={<AdminSavedProperties />} />
         <Route path='/admin-edit-classified-property/:id' element={<AdminEditClassifiedProperty />} />
        <Route path='/admin-users' element={<AdminUsers />} />
        <Route path='/admin-sub-admins' element={<AdminSubAdmins />} />
        <Route path='/admin-properties' element={<AdminAllProperties />} />
        <Route path='/admin-profile' element={<AdminProfile />} />
        <Route path='/admin-change-password' element={<AdminChangePassword />} />
        <Route path='/admin-add-property' element={<AdminAddProperty />} />
        <Route path='/admin-edit-property/:id' element={<AdminEditProperty />} />
        <Route path='/admin-amenities' element={<AdminAmenities />} />
        <Route path='/admin-bookings' element={<AdminBookings />} />
        <Route path='/admin-project-inquiries' element={<AdminInquiries filterType="Project Inquiry" />} />
        <Route path='/admin-locality-inquiries' element={<AdminInquiries filterType="Locality Inquiry" />} />
        <Route path='/admin-common-inquiries' element={<AdminInquiries filterType="Common Inquiry" />} />
        <Route path='/admin-inquiries' element={<AdminInquiries />} />
        <Route path='/admin-cities' element={<AdminCities />} />
        <Route path='/admin-developers' element={<AdminDevelopers />} />
        <Route path='/admin-add-developer' element={<AdminAddDeveloper />} />
        <Route path='/admin-edit-developer/:id' element={<AdminEditDeveloper />} />
        <Route path='/admin-podcasts' element={<AdminManagePodcasts />} />
        <Route path='/admin-reels' element={<AdminManageReels />} />
        <Route path='/admin-testimonials' element={<AdminTestimonials />} />
        <Route path='/admin-blogs' element={<AdminBlogs />} />
        <Route path='/admin-projects' element={<AdminProjects />} />
        <Route path='/admin-drafts' element={<AdminDrafts />} />
        <Route path='/admin-add-project' element={<AdminAddProject />} />
        <Route path='/admin-media' element={<AdminMedia />} />
        <Route path='/admin-edit-project/:id' element={<AdminEditProject />} />
        <Route path='/admin-inventory' element={<AdminInventory />} />
        <Route path='/admin-leads' element={<AdminLeads />} />
        <Route path='/admin-followups' element={<AdminFollowUps />} />
        <Route path='/admin-customers' element={<AdminCustomers />} />
        <Route path='/admin-icons' element={<AdminIcons />} />
        <Route path='/admin-specifications' element={<AdminSpecifications />} />
        <Route path='/admin-project-details' element={<AdminProjectDetails />} />
        <Route path='/admin-localities' element={<AdminLocalities />} />
        <Route path='/admin-add-locality' element={<AdminEditLocality />} />
        <Route path='/admin-edit-locality/:id' element={<AdminEditLocality />} />
        <Route path='/admin-blog-comments' element={<AdminBlogComments />} />
        <Route path='/admin-hero-banners' element={<AdminHeroBanners />} />
        <Route path='/admin-packages' element={<AdminPackages />} />
        <Route path='/admin-add-package' element={<AdminAddPackage />} />
        <Route path='/admin-edit-package/:id' element={<AdminEditPackage />} />
        <Route path='/admin-package-inquiries' element={<AdminPackageInquiries />} />
        <Route path='/admin-property-types' element={<AdminPropertyTypes />} />
        <Route path='/admin-add-property-type' element={<AdminAddPropertyType />} />
        <Route path='/admin-edit-property-type/:id' element={<AdminEditPropertyType />} />
        <Route path='/admin-property-subtypes' element={<AdminPropertySubtypes />} />
        <Route path='/admin-add-property-subtype' element={<AdminAddPropertySubtype />} />
        <Route path='/admin-locality-points' element={<AdminLocalityPoints />} />
        <Route path="/admin-price-trends" element={<AdminPriceTrends />} />
        <Route path="/admin-landmark-categories" element={<AdminLandmarkCategories />} />
        <Route path="/admin-locality-highlights" element={<AdminLocalityHighlights />} />
        <Route path="/admin-lead-settings" element={<AdminLeadSettings />} />
        <Route path="/admin-site-visibility" element={<AdminSiteVisibility />} />
        <Route path="/admin-homepage-settings" element={<AdminHomepageSettings />} />
        <Route path="/admin-score-management" element={<AdminScoreManagement />} />
        <Route path="/admin-seo" element={<AdminSEO />} />
        <Route path="/admin-legal" element={<AdminLegal />} />

        {/* Developer Panel Pages (Brown/Gold Theme) */}
        <Route path='/developer-dashboard' element={<DevDashboard />} />
        <Route path='/developer-profile' element={<DevProfile />} />
        <Route path='/developer-my-property' element={<DevMyProperty />} />
        <Route path='/developer-add-project' element={<DevAddProject />} />
        <Route path='/developer-edit-project/:id' element={<DevAddProject />} />
        <Route path='/developer-add-property' element={<DevAddProperty />} />
        <Route path='/developer-edit-property/:id' element={<DevAddProperty />} />
        <Route path='/developer-inventory' element={<DevInventory />} />
        <Route path='/developer-change-password' element={<DevChangePassword />} />
        <Route path='/developer-page/:id' element={<DeveloperPage />} />
        <Route path='/owner-profile/:id' element={<OwnerProfile />} />
        <Route path='/developer-drafts' element={<DevDrafts />} />
        
        {/* Shared Dashboard Pages */}
        <Route path='/my-package' element={<MyPackagePage />} />

        {/* Dedicated Role Dashboards */}
        <Route path='/buyer-dashboard' element={<BuyerDashboard />} />
        <Route path='/buyer-inquiries' element={<BuyerInquiries />} />
        <Route path='/tenant-dashboard' element={<TenantDashboard />} />
        
        {/* Standardized Owner Routes */}
        <Route path='/owner/dashboard' element={<OwnerDashboard />} />
        <Route path='/owner-dashboard' element={<OwnerDashboard />} /> {/* Legacy redirect support */}
        <Route path='/owner/profile' element={<AdminProfile />} />
        <Route path='/owner-property' element={<OwnerMyProperty />} />
        <Route path='/owner/my-property' element={<OwnerMyProperty />} />
        <Route path='/owner/your-property' element={<OwnerMyProperty />} />
        <Route path='/owner/edit-property/:id' element={<OwnerEditProperty />} />
        <Route path='/owner/add-property' element={<SubmitPropertyDashboard />} />
        <Route path='/owner-add-property' element={<OwnerAddProject />} />
        <Route path='/owner-edit-project/:id' element={<OwnerAddProject />} />
        <Route path='/owner/change-password' element={<AdminChangePassword />} />
        
        <Route path='/broker-dashboard' element={<BrokerDashboard />} />
        <Route path='/broker-profile' element={<BrokerProfile />} />
        <Route path='/broker-add-project' element={<BrokerAddProject />} />
        <Route path='/broker-my-projects' element={<BrokerMyProjects />} />
        <Route path='/broker-leads' element={<BrokerLeads />} />
        <Route path='/broker-inquiries' element={<BrokerInquiries />} />
        <Route path='/broker-wishlist' element={<BrokerWishlist />} />
        <Route path='/broker-buy-lead-plan' element={<BrokerBuyLeadPlan />} />
        <Route path='/broker-purchased-plans' element={<BrokerPurchasedPlans />} />
        <Route path='/broker-classified-ads' element={<BrokerClassifiedAds />} />
        <Route path='/saved-classified-leads' element={<SavedClassifiedLeads />} />
        <Route path='/broker-change-password' element={<BrokerChangePassword />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
      <ScrollToTop />
      <MobileBottomNav />
      <DisclaimerModal />
    </>
  );
}

export default App;
